import React from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

const Navegador = (props) => {

    let buttonSeleccionadoEmpresa = "btn btn";
    let buttonSeleccionadoCuenta = "btn btn";
    let buttonSeleccionadoTarjeta = "btn btn";
    switch (props.data.entidad) {
        case 0:
            if (props.data.empresaSolicitud) {
                buttonSeleccionadoEmpresa = "btn btn";
                buttonSeleccionadoCuenta = "btn btn-cta";
            }
            else {
                buttonSeleccionadoEmpresa = "btn btn-cta";
            }    
            break;
        case 1:
            if (props.data.cuentaSolicitud) {
                buttonSeleccionadoEmpresa = "btn btn";
                buttonSeleccionadoCuenta = "btn btn";
            }
            else {
                buttonSeleccionadoCuenta = "btn btn-cta";
            }
            break;
        case 2:
            buttonSeleccionadoTarjeta = "btn btn-cta";
            break;
    }

    let buttonEmpresa = <GenericSimpleButton buttonType="button" text="Empresa" buttonClass={buttonSeleccionadoEmpresa} onClick={() => props.goTo(0)} buttonType="button" />;
    let buttonCuenta = <GenericSimpleButton buttonType="button" text="Cuenta" buttonClass={buttonSeleccionadoCuenta} onClick={() => props.goTo(1)} buttonType="button" />;
    let buttonTarjeta = <GenericSimpleButton buttonType="button" text="Tarjeta" buttonClass={buttonSeleccionadoTarjeta} onClick={() => props.goTo(2)} buttonType="button" />;

    //Empresa Aceptada por Administradora, no se visualiza
    if (props.data.empresaSolicitud) {
        buttonEmpresa = undefined;
    }

    //Empresa y Cuenta Aceptada por Administradora, no se visualizan
    if (props.data.cuentaSolicitud) {
        buttonEmpresa = undefined;
        buttonCuenta = undefined;
    }

    return (
        <div className="row">
            <div className="col-xs-12">
                {buttonEmpresa}
                {buttonCuenta}
                {buttonTarjeta}
            </div>
        </div>
    );
}

export default Navegador;